const confirmDialogStyle = {
  customCancelBookingContainer: {
    borderRadius: '10px',
    margin: '10 10 10 10',
    paddingTop: '15px',
    paddingLeft: '25px',
    paddingRight: '30px',
  },
  customCancelBookingHeader: {
    fontSize: 'var(--fs-18, 1.125rem)',
    fontWeight: '400',
    // textTransform: 'uppercase',
  },
  customCancelBookingMessage: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  customCancelBookingCancelButton: {
    fontSize: 'var(--fs-16, 1rem)',
  },
  customCancelBookingConfirmButton: {
    fontSize: 'var(--fs-16, 1rem)',
  },
}

export default confirmDialogStyle
